import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Divider,
  Form,
  Button,
  Typography,
  Row,
  Col,
  Modal,
  Table,
  Card,
  Grid,
} from "antd";
import { useUser } from "../../contexts/UserContext";
import { EditOutlined } from "@ant-design/icons";
import getColumns from "../../components/checkout/Columns";
import EditDeliveryAddressForm from "../../components/checkout/EditDeliveryAddressForm";
import axios from "axios";
import { apiEndpoint } from "../../constants/constants";

const { Text, Title } = Typography;
const { useBreakpoint } = Grid;

const CartCheckout = () => {
  const location = useLocation();
  const { selectedItems } = location.state || { selectedItems: { items: [] } };
  const { currentUser } = useUser();
  const [visible, setVisible] = useState(false);
  const [address, setAddress] = useState(currentUser.address);
  const [unitNumber, setUnitNumber] = useState(currentUser.unitNumber);

  const screens = useBreakpoint();

  const totalPrice = selectedItems?.items?.reduce(
    (sum, item) => sum + item.quantity * item.product.price,
    0,
  );

  const columns = getColumns(screens);

  const dataSource = selectedItems.items.map((item, index) => ({
    key: index,
    product: item.product,
    quantity: item.quantity,
    price: item.product.price,
    total: item.quantity * item.product.price,
  }));

  const onFinish = async () => {
    const seller = selectedItems.items[0].product.seller;
    localStorage.setItem(
      "checkOutData",
      JSON.stringify({
        selectedItems,
        shippingAddress: address,
        unitNumber,
        totalPrice,
        cartCheckout: true,
        seller,
      }),
    );

    const response = await axios.post(
      `${apiEndpoint}/stripe/checkout-session`,
      {
        buyer: currentUser,
        seller,
        items: selectedItems.items,
      },
    );

    window.location.href = response.data.url;
  };

  return (
    <div
      style={{
        maxWidth: "900px",
        margin: "0 auto",
        padding: screens.xs ? "12px 8px" : "32px 16px",
      }}
    >
      <Title level={2} style={{ marginBottom: "20px" }}>
        Checkout
      </Title>

      {/* Address Card Container */}
      <Card
        style={{
          marginBottom: "20px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
        }}
        styles={{ body: { padding: screens.xs ? "12px" : "20px" } }}
      >
        <Row justify="space-between" align="middle" gutter={[12, 12]}>
          <Col xs={20} sm={21}>
            <Text
              type="secondary"
              style={{ fontSize: "12px", display: "block" }}
            >
              SHIPPING ADDRESS
            </Text>
            <Text strong style={{ fontSize: screens.xs ? "14px" : "16px" }}>
              {address} {unitNumber && `, Unit Number: ${unitNumber}`}
            </Text>
          </Col>
          <Col xs={4} sm={3} style={{ textAlign: "right" }}>
            <Button
              shape="circle"
              type="primary"
              ghost
              icon={<EditOutlined />}
              onClick={() => setVisible(true)}
            />
          </Col>
        </Row>
      </Card>

      {/* Responsive Table */}
      <Card
        styles={{ body: { padding: 0 } }}
        style={{ boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}
      >
        <Table
          columns={columns}
          dataSource={dataSource}
          pagination={false}
          size={screens.xs ? "small" : "default"} // Compact padding on mobile
          scroll={{ x: true }}
          summary={() => (
            <Table.Summary.Row>
              <Table.Summary.Cell
                colSpan={3}
                align="right"
                style={{ padding: screens.xs ? "8px 4px" : undefined }}
              >
                <Text
                  strong
                  style={{
                    fontSize: screens.xs ? "13px" : "18px",
                    whiteSpace: "nowrap",
                  }}
                >
                  Total Price:
                </Text>
              </Table.Summary.Cell>
              <Table.Summary.Cell
                align="center"
                style={{ padding: screens.xs ? "8px 4px" : undefined }}
              >
                <Text
                  strong
                  type="danger"
                  style={{
                    fontSize: screens.xs ? "14px" : "20px",
                    whiteSpace: "nowrap",
                  }}
                >
                  ${totalPrice.toFixed(2)}
                </Text>
              </Table.Summary.Cell>
            </Table.Summary.Row>
          )}
        />
      </Card>

      <Divider style={{ margin: "24px 0" }} />

      {/* Form Submission */}
      <Form name="checkout" layout="vertical" onFinish={onFinish}>
        <Form.Item style={{ marginBottom: 0 }}>
          <Button
            type="primary"
            htmlType="submit"
            size="large"
            block={screens.xs}
            style={{ minWidth: "200px", float: screens.xs ? "none" : "right" }}
          >
            Proceed to Payment
          </Button>
        </Form.Item>
      </Form>

      <Modal
        open={visible}
        footer={false}
        closable={true}
        onCancel={() => setVisible(false)}
        title="Shipping Address"
        centered
      >
        <EditDeliveryAddressForm
          setAddress={setAddress}
          setUnitNumber={setUnitNumber}
          setVisible={setVisible}
        />
      </Modal>
    </div>
  );
};

export default CartCheckout;
